import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["description", "listingHref", "name", "providerName", "actions", "certified", "imageSrcBig", "imageSrcSmall", "installed", "linkMode", "metaBadges", "onActionClick"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { HubspotCertificationIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Image } from 'foundations-components/transitional/components/Image';
import { Link } from 'foundations-components/transitional/components/Link';
import { StatusTag } from 'foundations-components/transitional/components/StatusTag';
import { useMemo, useState } from 'react';
import { ListingActionMenu } from '../ListingActionMenu';
import { PolymorphicLink } from '../PolymorphicLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EcosystemListingCard(_ref) {
  let {
      description,
      listingHref,
      name,
      providerName,
      actions = [],
      certified = false,
      imageSrcBig,
      imageSrcSmall,
      installed,
      linkMode = 'default',
      metaBadges = [],
      onActionClick = () => {}
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [isHovered, setIsHovered] = useState(false);
  const sName = useMemo(() => splitName(name), [name]);
  return /*#__PURE__*/_jsxs(CardWrapper, Object.assign({
    compact: true,
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false)
  }, props, {
    children: [/*#__PURE__*/_jsx(PolymorphicLink, {
      linkMode: linkMode,
      href: listingHref,
      children: /*#__PURE__*/_jsxs(View, {
        backgroundColor: "fill-surface-raised",
        blockSize: "164px",
        borderStartEndRadius: "100",
        borderStartStartRadius: "100",
        overflow: "hidden",
        position: "relative",
        children: [imageSrcBig && /*#__PURE__*/_jsx(Image, {
          blockSize: "164px",
          inlineSize: "100%",
          objectFit: "cover",
          src: imageSrcBig
        }), imageSrcSmall && /*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          inset: "0",
          justifyContent: "center",
          position: "absolute",
          children: /*#__PURE__*/_jsx(Image, {
            src: imageSrcSmall,
            blockSize: "100px"
          })
        })]
      })
    }), actions.length > 0 && isHovered && /*#__PURE__*/_jsx(View, {
      position: "absolute",
      insetInlineEnd: "16px",
      insetBlockStart: "16px",
      children: /*#__PURE__*/_jsx(ListingActionMenu, {
        actions: actions,
        onActionClick: onActionClick
      })
    }), /*#__PURE__*/_jsxs(CardSection, {
      flexGrow: 1,
      display: "flex",
      flexDirection: "column",
      children: [/*#__PURE__*/_jsx(PolymorphicLink, {
        href: listingHref,
        linkMode: linkMode,
        use: "unstyled",
        children: /*#__PURE__*/_jsxs(Text, {
          as: "h4",
          marginBlockEnd: "50",
          children: [sName.allButLastWord, /*#__PURE__*/_jsxs("span", {
            style: {
              whiteSpace: 'nowrap'
            },
            children: [sName.lastWord, certified && /*#__PURE__*/_jsx(IconHolder, {
              icon: HubspotCertificationIcon,
              color: "fill-brand-default",
              padding: "0",
              marginInlineStart: "100"
            })]
          })]
        })
      }), /*#__PURE__*/_jsx(Text, {
        as: "small",
        color: "text-core-subtle",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "trellisEcosystem.appCard.providerName",
          options: {
            providerName
          }
        })
      }), /*#__PURE__*/_jsx(Text, {
        marginBlock: "300",
        children: description
      }), /*#__PURE__*/_jsxs(Flex, {
        alignItems: "end",
        gap: "200",
        marginBlockStart: "auto",
        children: [metaBadges.map(metaBadge => /*#__PURE__*/_jsx(Link, {
          href: metaBadge.href,
          children: /*#__PURE__*/_jsx(Badge, {
            use: "koala",
            children: /*#__PURE__*/_jsxs(Flex, {
              alignItems: "center",
              gap: "100",
              children: [metaBadge.label, metaBadge.icon]
            })
          })
        }, metaBadge.label)), installed && /*#__PURE__*/_jsx(StatusTag, {
          use: "success",
          marginInlineStart: "100",
          marginBlockEnd: "50",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "trellisEcosystem.appCard.installed"
          })
        })]
      })]
    })]
  }));
}
function splitName(name) {
  const split = name.split(/\s+/);
  let allButLastWord = split.slice(0, -1).join(' ');
  if (split.length > 1) allButLastWord += ' ';
  return {
    allButLastWord,
    lastWord: split.pop()
  };
}